import React from 'react';
import { Image } from 'antd';
import { Modal } from 'shared/ui/Modal';
import { Button } from 'shared/ui/Button';
import { InfoTag } from 'shared/ui/InfoTag';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { VerificationDocument, getAccessToken } from 'entities/User';
import { API_URL } from 'app/config/envVariables';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';

interface MoveOutPhotosModalProps {
  isOpen: boolean;
  onClose: () => void;
  photos: VerificationDocument[];
  contractId: string;
}

export const MoveOutPhotosModal: React.FC<MoveOutPhotosModalProps> = ({ isOpen, onClose, photos, contractId }) => {
  const { t } = useAppTranslation(['common', 'contracts']);

  const token = getAccessToken();
  const { isDesktop } = useScreenBreakpoints();

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={isDesktop ? 980 : 380}>
      <div className="flex justify-between font-semibold text-3xl mb-5">{t('Move out photos', { ns: 'contracts' })}</div>

      <InfoTag textSize="medium">
        {t('Before closing the contract, make sure that the client has completely vacated the box.', { ns: 'contracts' })}
      </InfoTag>

      {photos.length === 0 ? (
        <div className="text-gray-500 text-center py-8">{t('No uploaded photos', { ns: 'contracts' })}</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 p-4">
          {photos.map((photo) => (
            <div key={photo.verificationPhotoId} className="flex flex-col items-center space-y-2 border rounded-lg shadow-sm p-2">
              <Image
                src={`${API_URL}/contracts/${contractId}/move-out-photos/${photo.name}?token=${token}`}
                alt={photo.name}
                className="rounded-lg object-cover w-full"
              />
            </div>
          ))}
        </div>
      )}

      <div className="flex justify-end mt-4">
        <Button onClick={onClose}>{t('Close')}</Button>
      </div>
    </Modal>
  );
};
